module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD ]),
      expression: "[\n              USER_ROLES.ADMIN,\n              USER_ROLES.SUPER_ADMIN,\n              USER_ROLES.GA_HEAD,\n            ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTripModal
    }
  }, [_vm._v("\n              Delete Trip\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_list,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.selectGA
    },
    model: {
      value: (_vm.trip.region),
      callback: function($$v) {
        _vm.$set(_vm.trip, "region", $$v)
      },
      expression: "trip.region"
    }
  })], 1), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                    Geographical Area is a required field\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.vehicle_no,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.getDeviceName
    },
    model: {
      value: (_vm.trip.vehicleId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "vehicleId", $$v)
      },
      expression: "trip.vehicleId"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                    Drivers\n                  ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.driverStatus
    },
    model: {
      value: (_vm.trip.driverId),
      callback: function($$v) {
        _vm.$set(_vm.trip, "driverId", $$v)
      },
      expression: "trip.driverId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "required": "",
      "not-before": _vm.disabledBefore,
      "disabled": "",
      "lang": "en",
      "name": "scheduleDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduleTime",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.trip.scheduleTime),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleTime", $$v)
      },
      expression: "trip.scheduleTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.region_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.HCVOperationStatus
    },
    model: {
      value: (_vm.trip.regionManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "regionManager", $$v)
      },
      expression: "trip.regionManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "value",
      "options": this.journey_managers,
      "searchable": true,
      "language": "en-US"
    },
    on: {
      "input": _vm.journeyManagerStatus
    },
    model: {
      value: (_vm.trip.journeyManager),
      callback: function($$v) {
        _vm.$set(_vm.trip, "journeyManager", $$v)
      },
      expression: "trip.journeyManager"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.remark),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.remark),
      expression: "trip.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remark",
      "placeholder": "Remarks"
    },
    domProps: {
      "value": (_vm.trip.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.trip, "remark", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [(index === 0) ? _c('label', [_vm._v("Start Location")]) : (index === _vm.locations.length - 1) ? _c('label', [_vm._v("End Location")]) : _c('label', [_vm._v("Halt " + _vm._s(index))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": "",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.getFilteredLocationList(
      index
    )), function(item, itemIndex) {
      return _c('option', {
        key: itemIndex,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                        " + _vm._s(item.siteName) + "\n                      ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1)], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripGroup'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n              USER_ROLES.ADMIN,\n              USER_ROLES.SUPER_ADMIN,\n              USER_ROLES.GA_HEAD,\n              USER_ROLES.JOURNEY_MANAGER,\n            ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "disabled": !(_vm.formValid),
      "type": "submit"
    },
    on: {
      "click": _vm.updateTripGroupDetails
    }
  }, [_vm._v("\n                Update Group Trip\n              ")])])], 1)], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "gasFlowDia",
      "height": "425",
      "adaptive": false,
      "click-to-close": false
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modal-basic-title"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('gasFlowDia')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Start Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.startLocation),
      expression: "routeData.startLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.startLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "startLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("End Location:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.endLocation),
      expression: "routeData.endLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Approx. Distance",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.routeData.endLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "endLocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Time (in Min) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.time),
      expression: "routeData.time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Approx. Distance(km) :")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.distance),
      expression: "routeData.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.routeData.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.routeData, "distance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "marginTop": "10px"
    }
  }, [_c('th', [_vm._v("Region :")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeData.region),
      expression: "routeData.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.routeData, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                " + _vm._s(item.value) + "\n              ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeRoute()
      }
    }
  }, [_vm._v("Close")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fae3873"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip-group/TripGroupDetail.vue
// module id = 1980
// module chunks = 1